import { createApp } from 'vue'
import App from './App.vue'
import BootstrapVue3 from 'bootstrap-vue-3'
import jQuery from 'jquery'
import Router from './router'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css'

global.$ = jQuery

createApp(App).use(BootstrapVue3)
    .use(Router)
    .mount('#app')
